import {
  MEMBERLIST_FETCHITEMS_LOAD,
  MEMBERLIST_FETCHITEMS_SUCCEED,
  MEMBERLIST_FETCHITEMS_FAIL,
  MEMBERLIST_CHANGETABLE_CHANGE,
  MEMBERLIST_SEARCHTABLE_EDIT,
  MEMBERLIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case MEMBERLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case MEMBERLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case MEMBERLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case MEMBERLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case MEMBERLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case MEMBERLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}
